'use client';

import { FC } from 'react';

import {
  Carousel,
  CarouselArrow,
  CarouselContent,
  CarouselItem,
} from '@wwe-portal/ui/components/carousel';
import { Superstar } from '@wwe-portal/entities/superstar.type';
import Image from 'next/image';

import { extractSuperstarName } from '@wwe-portal/web/utils/superstar-details/extractor';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { Skeleton } from '@wwe-portal/ui/components/skeleton';
import { SuperstarLink } from '../common/link/superstar-link';

const WrestlerCarouselItem: FC<{ superstar: Superstar }> = ({ superstar }) => {
  const { mainString, subString } = extractSuperstarName(superstar.name) ?? {};
  return (
    <CarouselItem
      key={superstar.groupId}
      className="basis-[275px] pl-5 md:basis-[163px]"
    >
      <div className="flex h-[460px] flex-col items-center gap-8 pt-12 md:h-[332px] md:pt-6">
        <SuperstarLink superstarId={superstar.groupId}>
          <Image
            src={superstar.image}
            alt={superstar.name}
            width={255}
            height={334}
            className="h-[334px] shrink-0 grow-0 basis-[334px] object-contain md:h-[188px] md:basis-[188px]"
          />
        </SuperstarLink>
        <SuperstarLink superstarId={superstar.groupId}>
          <div className="text-chetwodeBlue text-center text-sm">
            <div className="hover:text-green700 mb-1">{mainString}</div>
            <div className="text-xs">{subString}</div>
          </div>
        </SuperstarLink>
      </div>
    </CarouselItem>
  );
};

export const WrestlerCarousel: FC<{ superstars: Superstar[] }> = ({
  superstars,
}) => {
  const { isMobile, isHydrated } = useResponsive();
  if (!isHydrated)
    return (
      <div className="h-[460px] w-full px-5">
        <Skeleton className="h-full w-full" />
      </div>
    );
  const maxItems = isMobile ? 5 : 20;
  return (
    <Carousel
      className="mx-[-30px] overflow-hidden"
      opts={{ align: isMobile ? 'start' : 'center' }}
    >
      <CarouselContent className="ml-0">
        {superstars.slice(0, maxItems).map((superstar) => (
          <WrestlerCarouselItem key={superstar.groupId} superstar={superstar} />
        ))}
      </CarouselContent>
      <CarouselArrow className="hidden md:block" />
    </Carousel>
  );
};
